import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/GLADASKOJAR/"

const gladaskojar: CommunityData = {
  code: "gladaskojarna",
  inviteCode: "gladaskojarna",
  name: "Glada Skojarna",
  thumbnail: "https://media.werz.at/community-assets/GLADASKOJAR/web-thumbnail.png",
  favicon: "",
  defaultCurrency: "SEK",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/gla-332`,
  socials: {},
  styles: {
    global: {
      counterColor: "#ffffff",
      logo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-32 h-32",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-32 h-32",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#acfee5",
      asideBg: "#acfee5",
      asideStyles: "",
      contentBg: "#acfee5",
      contentBoxShadow: "!rounded-3xl",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background.jpg`,
      mainFont: "font-['RecoletaRegular']",
      primaryButton:
        "bg-black border border-black rounded-lg px-6 py-4 !text-white font-['RecoletaRegular'] !text-base text-left",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "",
      separator: "#000000b2",
      item: "text-black font-['RecoletaMedium'] text-base text-center -ml-2 border-b border-[#000000] border-opacity-70 text-opacity-50 !py-2",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#acfee5] !rounded-3xl !pb-8",
      titles: "text-black font-['SuperPowerRegular'] text-[38px] text-left leading-[100%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-black/50 font-['RecoletaRegular'] text-sm text-left",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0",
        sectionTitle:
          "text-black font-['SuperPowerRegular'] text-[38px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#acfee5]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative ",
          media: "w-full !aspect-square object-cover rounded-[12px]",
          placeholderMedia: "w-full h-[256px] sm:h-[144px] bg-gray-400 rounded-[12px]",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-black font-['SuperPowerRegular'] text-[28px] text-left leading-[100%]",
          subtitle: "text-black/50 font-['RecoletaRegular'] text-sm text-left",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0",
        sectionTitle:
          "text-black font-['SuperPowerRegular'] text-[38px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#acfee5]",
          mediaContainer:
            "w-full sm:!w-[228px] h-[183px] sm:!h-[128px] sm:flex-shrink-0 relative  !rounded-[12px] overflow-hidden",
          media: "w-full !aspect-video object-cover !rounded-[12px]",
          placeholderMedia: "w-full h-full bg-gray-400 !rounded-[12px]",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent p-4",
          title: "text-black font-['RecoletaMedium'] text-[16px] text-left leading-[100%] mb-2",
          subtitle: "text-black/50 font-['RecoletaRegular'] text-[12px] text-left mb-1",
          location: "text-black/50 font-['RecoletaRegular'] text-[12px] text-left",
          date: "text-black/50 font-['RecoletaRegular'] text-[12px] text-left",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-black font-['SuperPowerRegular'] text-[34px] text-left leading-[100%]",
        text: "text-black font-['RecoletaRegular'] text-base text-left",
        customShopImageStyle: "rounded-xl",
        sectionTitle:
          "text-black font-['SuperPowerRegular'] text-[34px] text-left leading-[100%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#acfee5] rounded-3xl !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0 rounded-xl",
        title: "text-black font-['SuperPowerRegular'] text-[38px] text-left leading-[100%] mb-2",
        subtitle: "text-black/50 font-['RecoletaRegular'] text-sm text-left !mb-1",
        button:
          "bg-black border border-black rounded-lg px-6 py-4 !text-white font-['RecoletaRegular'] !text-base text-left !my-1 !w-fit",
        questions: "text-sm text-left",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-black font-['SuperPowerRegular'] text-[34px] text-left leading-[100%]",
        text: "text-black font-['RecoletaRegular'] text-sm text-left",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-black font-['SuperPowerRegular'] text-[34px] text-left leading-[100%]",
        text: "text-black font-['RecoletaRegular'] text-sm text-left",
        map: "w-full h-[206px] overflow-hidden border border-black/20 gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-black font-['SuperPowerRegular'] text-[34px] text-left leading-[100%]",
        text: "text-black font-['RecoletaRegular'] text-sm text-left",
      },
      tickets: {
        header:
          "text-black font-['SuperPowerRegular'] text-[34px] text-left leading-[100%] px-4 sm:px-8 pt-4 sm:pt-8 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#acfee5] rounded-3xl !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-black border border-black rounded-lg px-4 py-3 text-white font-['RecoletaRegular'] text-sm text-left !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto !bg-[#acfee5] border-b border-black/70 py-4 mb-4",
          media: "!hidden",
          name: "text-black font-['RecoletaMedium'] text-base text-left leading-[100%]",
          description: "text-black/50 font-['RecoletaRegular'] text-sm text-left !mt-1",
          price: "text-black/50 font-['RecoletaMedium'] text-base text-left leading-[100%] !mt-1",
          quantity: "text-white font-['RecoletaRegular'] text-sm text-left",
          status: "text-black/50 font-['RecoletaMedium'] text-base text-left leading-[100%]",
          counterContainer:
            "bg-black border border-black rounded-lg px-4 py-3 gap-x-4 !w-fit !h-10",
          button:
            "bg-black border border-black rounded-lg px-4 py-3 text-white font-['RecoletaRegular'] text-sm text-left !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
  },
}

export default gladaskojar
